import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import LanguageSwitcher from "../../LanguageSwitcher";

const Header2 = ({ pageTitle, onSidebarToggle }) => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState(""); // للبحث (اختياري)

  // State للـ menu toggle (لو عايز nav menu داخلي، بس دلوقتي مش مستخدم)
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="w-full bg-header-background px-4 sm:px-6 lg:px-6 py-6">
      <div className="flex flex-row sm:flex-row justify-between items-center sm:items-center gap-4 w-full">
    {/* Right: Title (أقصى اليمين) */}
        <h1 className="text-xl sm:text-2xl font-bold text-text-accent flex-shrink-0">
          {t(pageTitle)}
        </h1>
    
    
       

        {/* Middle: Search Bar (مرئي على الشاشات الكبيرة فقط، في الوسط) */}
        <div className="hidden sm:flex flex-1 max-w-[400px] justify-center">
          <div className="relative w-full max-w-[400px]">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // أضفت functionality بسيطة
              placeholder={t("search_hint") || "Search..."}
              className="w-full px-8 py-2 text-base bg-secondary-light rounded-2xl border-none outline-none text-background-overlay focus:ring-2 focus:ring-blue-500"
            />
            <img
              src="/images/img_search_gray_600.svg"
              alt="Search icon"
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-6 h-6 opacity-70"
            />
          </div>
        </div>

         {/* Left: Icons (LanguageSwitcher and Profile, with Hamburger on mobile) */}
        <div className="flex items-center gap-2 sm:gap-5 flex-nowrap">
          {/* Hamburger Menu Icon - مرئي فقط على الموبايل */}
          <button
            type="button"
            onClick={onSidebarToggle} // هتفتح/تقفل الـ Sidebar
            className="lg:hidden flex flex-col justify-center items-center gap-1 w-6 h-6 p-1 cursor-pointer rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            aria-label={t("open_menu") || "Open sidebar menu"}
          >
            {/* ثلاث خطوط CSS (بدل صورة، عشان سهلة ومرئية) */}
            <span className={`block w-6 h-0.5 bg-gray-800 transition-all duration-300 rounded`} />
            <span className={`block w-6 h-0.5 bg-gray-800 transition-all duration-300 rounded`} />
            <span className={`block w-6 h-0.5 bg-gray-800 transition-all duration-300 rounded`} />
          </button>

          <LanguageSwitcher />

          <img
            src="/images/img_17_picture.png"
            alt="Profile"
            className="hidden sm:block w-10 h-10 rounded-full cursor-pointer hover:opacity-80 transition-opacity"
          />
        </div>

        
      </div>

      {/* لو عايز mobile nav menu داخلي (غير الـ Sidebar)، ضعه هنا */}
      {/* {menuOpen && (
        <nav className="lg:hidden mt-4 p-4 bg-white rounded-lg shadow-md">

        </nav>
      )} */}
    </header>
  );
};

export default Header2;
